import { useContext } from 'react';

import { formContext } from '../contexts';

export const useFormContext = () => useContext(formContext);
